import StandardPage from '../templates/StandardPage';
import Hero from '../components/organisms/hero';
import Button from '../components/atoms/button';
import Container from '../components/atoms/container';
import ContentItem from '../components/molecules/contentitem';
import './home.css';

const bio = [
  {
    image: '/img/bio1.jpg',
    title: 'Bold Flavors',
    description: 'Our avant-garde dishes will take you on a culinary journey like no other, with the perfect balance of eye-catching presentation and mouth-watering flavors.'
  },
  {
    image: '/img/bio2.jpg',
    title: 'Creative Cocktails',
    description: 'Our mixologists are always experimenting with new flavors and techniques to bring you the most unique and delicious cocktails in the area.'
  },
  {
    image: '/img/bio3.png',
    title: 'Ambient Vibe',
    description: 'Soak in the ambient vibes as you settle into our spacious, monochromatic dining space adorned with modern art and clean lines.'
  }
];

const Home = () => {
  return (
    <StandardPage>
      <Hero>
        <div class="button-container">
          {/* <Button variant="contained" className="mobile-menu-button">Menu</Button> */}
          <Button variant="outlined">Reserve Now</Button>
          {/* <Button variant="outlined">Order Online</Button> */}
        </div>
      </Hero>
      <Container>
        <div class="bio-section">
          {bio.map((item, index) => (
            <ContentItem key={index} content={item} />
          ))}
        </div>
      </Container>
      <Container>
        <div class="history-section">
          <div class="history-section-primary">
            <img src="/img/history1.png" alt="placeholder" />
            <div class="history-section-text">
              <h4>Something about our history</h4>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl quis ultricies ultricies, nunc nisl ultricies nunc, quis ultricies nisl nisl vitae nisl. Sed euismod, nisl quis ultricies ultricies, nunc nisl ultricies nunc, quis ultricies nisl nisl vitae nisl.
              </p>
            </div>
          </div>
          <div class="history-section-secondary">
            <div class="history-section-text">
              <h4>Something about our history</h4>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl quis ultricies ultricies, nunc nisl ultricies nunc, quis ultricies nisl nisl vitae nisl. Sed euismod, nisl quis ultricies ultricies, nunc nisl ultricies nunc, quis ultricies nisl nisl vitae nisl.
              </p>
            </div>
            <img src="/img/history2.png" alt="placeholder" />
          </div>
        </div>
      </Container>
    </StandardPage>
  );
}

export default Home;